import { t } from "i18next";
import { PositionXType, PositionYType } from "../../../interfaces/types";

import { AlignBottom } from "../../shared/Icons/AlignBottom";
import { AlignCenterHorizontal } from "../../shared/Icons/AlignCenterHorizntal";
import { AlignCenterVertical } from "../../shared/Icons/AlignCenterVertical";
import { AlignLeft } from "../../shared/Icons/AlignLeft";
import { AlignRight } from "../../shared/Icons/AlignRight";
import { AlignTop } from "../../shared/Icons/AlignTop";
import { IOption, SelectIcons } from "../SelectIcons";
import Typography from "../../shared/typography/Typography";

import { Actions, Container, IconContainer } from "./style";

interface IProps {
  alignX: PositionXType;
  setAlignX: React.Dispatch<PositionXType>;
  alignY: PositionYType;
  setAlignY: React.Dispatch<PositionYType>;
  menuDisplayMode?: boolean;
  style?: React.CSSProperties;
}

const optionsAlignHorizontal: IOption[] = [
  {value: 'left', icon: <AlignLeft />},
  {value: 'center', icon: <AlignCenterHorizontal />},
  {value: 'right', icon: <AlignRight />},
];

const optionsAlignVertical: IOption[] = [
  {value: 'top', icon: <AlignTop />},
  {value: 'center', icon: <AlignCenterVertical />},
  {value: 'end', icon: <AlignBottom />},
];

export const AlignActions = ({alignX, setAlignX, alignY, setAlignY, menuDisplayMode=false, style}: IProps) => {
  return (
    <Container style={style}>
      <Actions menuDisplayMode={menuDisplayMode}>
        <Typography className="title" type="paragraphXXS" color="title">{t("alignment")}</Typography>

        { menuDisplayMode ? (
          <SelectIcons 
            options={optionsAlignHorizontal}
            selected={alignX} 
            setSelected={setAlignX} 
            secondaryOptions={optionsAlignVertical} 
            secondarySelected={alignY} 
            secondarySetSelected={setAlignY} 
          />
        ) : (
          <>
            {optionsAlignHorizontal.map( option => (
              <IconContainer
                key={option.value}
                onClick={() => setAlignX(option.value as PositionXType)} 
                active={alignX === option.value}
              >
                {option.icon}
              </IconContainer>
            ))}

            {optionsAlignVertical.map( option => (
              <IconContainer 
                key={option.value}
                onClick={() => setAlignY(option.value as PositionYType)} 
                active={alignY === option.value}
              >
                {option.icon}
              </IconContainer>
            ))}
          </>
        )}
      </Actions>
    </Container>
  );
}